import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { environment as ENV } from 'environments/environment';

@Component({
  selector: 'wl-input-nolabel',
  templateUrl: './input-nolabel.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNoLabelComponent),
      multi: true
    },
  ]
})
export class InputNoLabelComponent implements ControlValueAccessor {

  @Input() label: string;
  @Input() type: string;
  @Input() required = false;
  @Input() error: string;
  @Input() disabled: boolean = true;
  @Input() readonly: boolean;
  @Input() style: string='text-align:center;width:10vw; margin-right: 20px;';
  // @Input() style: string;
  @Input() placeholder: string;
  // disabled = true; // Change this to enable input fields


  private _value: any;
  get value(): any { return this._value; }
  set value(v: any) { this._value = v; this.onChange(v); }

  constructor() {
    this.disabled = ENV.disableInput;
   }

  private onChange = (_) => { };

  private onTouched = () => { };

  writeValue(value: any) { this.value = value }

  registerOnChange(fn) { this.onChange = fn }

  registerOnTouched(fn) { this.onTouched = fn }

  setDisabledState(isDisabled) { this.disabled = isDisabled }

}
